// import moment from "moment";
import axios from "axios";
import { url } from "../../src/Values/constants";
import {
  showSnackbarAction,
  setFilterObject
} from "../Redux/actions";
import { convertToFilterString, uploadFileToS3 } from "../Values/utils";
import axiosHandler from "./axiosHandler";

export const uploadProjectsFileToMongo = async (
  fileUrl: string,
  organization_id: string,
  uid: string,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken: any,
  request_id: any
) => {

  try {

    let apiData = {
      fileUrl,
      organization_id,
      created_by: uid,
      uid: uid,
      request_id
    }
    // axios.defaults.headers.common['x-access-token'] = authToken;
    let res = await axiosHandler.post(url + '/dataUploadRequest/uploadProjects', apiData);
    dispatcher(
      showSnackbarAction(res.data.message, "success")
    );
    setLoad(false);
    window.location.reload();
  } catch (error: any) {
    throw error;
  }
};

export const fetchProjectsFileFromMongo = async (
  organization_id: string,
  uid: string,
  type: string,
  setUploadFiles: (data: any[]) => void,
  // dispatcher: any,
  // authToken: any
) => {
  try {
    let apiData: any = {
      organization_id,
      uid,
      type
    };
    const res: any = await axiosHandler.get(url + '/dataUploadRequest/fetchAll', {
      params: apiData,
    });
    setUploadFiles(res.data.data);

    // if (data) {
    //   setUploadFiles(data.data);
    // } else {
    //   setUploadFiles([]);
    // }
  } catch (error) {
    console.log("Projects fetch Error", error);
    setUploadFiles([]);
  }
};

export const createProjectMongo = async (
  organization_id: string,
  created_by: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => any,
  authToken: any,
  uid: any,
  business_vertical?: any,
  project_name?: any,
  developer_name?: any,
  address?: any,
  property_stage?: any,
  project_status?: any,
  property_type?: any,
  rera_link?: any,
  walkthrough_link?: any,
  ownerNameRef?: any,
  ownerContactRef?: any,
  priceRef?: number,
  unitRef?: any,
  selectedButton?:any,
  description?:any
) => {
// console.log("try try try")
  try {
    let apiData = {
      organization_id,
      uid,
      project_name,
      developer_name,
      address,
      rera_link,
      property_stage,
      project_status,
      walkthrough_link,
      property_type,
      created_by,
      business_vertical,
      ownerNameRef,
      ownerContactRef,
      priceRef,
      unitRef,
      type: selectedButton,
      description
    }
console.log("api data",apiData)
    // axios.defaults.headers.common['x-access-token'] = authToken;
    const res = await axiosHandler.post(url + '/projects/create', apiData);
    dispatcher(
      showSnackbarAction(res.data.message, "success")
    );
    setLoad(false);
    history.push("./projects");
  } catch (error: any) {
    dispatcher(
      showSnackbarAction(error.response.data.message, "error")
    );
    setLoad(false);
  }
};

export const updateProjectMongo = async (
  
  dispatcher: any,
  setLoad: (data: boolean) => void,
  business_vertical: any,
  authToken: any,
  uid: any,
  id: any,
  history?: any,
  project_name?: string,
  developer_name?: string,
  address?: string,
  property_type?: string,
  project_status?: string,
  property_stage?: string,
  rera_link?: string,
  walkthrough_link?: string,
  ownerNameRef?:any,
  ownerContactRef?:number,
  priceRef?:number,
  unitRef?:any,
  type?:any,
  description?:any
) => {
  try {
    let apiData = {
      data: {
        project_name,
        developer_name,
        address,
        rera_link,
        property_stage,
        project_status,
        walkthrough_link,
        property_type,
        modified_by: uid,
        business_vertical,
        owner_name:ownerNameRef,
        owner_contact_no:ownerContactRef,
        price:priceRef,
        unit_no:unitRef,
        type,
        description
      },
      id
    }
// console.log("apiData",apiData)
    // axios.defaults.headers.common['x-access-token'] = authToken;
    const res = await axiosHandler.put(url + '/projects/update', apiData);
    dispatcher(showSnackbarAction(res.data.message, 'success'));
    setLoad(false);
    history.push("./projects");
  } catch (error: any) {
    dispatcher(
      showSnackbarAction(error.response.data.message, "error")
    );
    setLoad(false);
  }
};

export const fetchProjectsMongo = async (
  organization_id: string,
  setProjects: (data: any[]) => void,
  authToken: string,
  setCount: (data: any) => void,
  filters: any,
  sort: any,
  limit: any,
  page: any,
  searchQuery: any,
  setLoad: (load: boolean) => void,
  oldData: any,
  isFinished: any,
  setIsFinished: (load: boolean) => void,
  paginate?: boolean,
  localPageSize?: Number,
  localPage?: Number,
  tempIsFinished?: boolean,
) => {
  try {
    if (isFinished === true && tempIsFinished !== false) {
      return;
    }
    let stringFilters: string = convertToFilterString(filters);
    let records = localPageSize ? localPageSize : limit;
    let apiData: any = {
      organization_id: organization_id,
      sort:  Object.keys(sort).length === 0
      ? { created_at: "-1" }
      : sort,
      filters: stringFilters,
      page: localPage ? localPage : page + 1,
      limit: localPageSize ? localPageSize : limit,
      search: searchQuery
    };
    setLoad(true);
    // axios.defaults.headers.common['x-access-token'] = authToken;
    const res = await axiosHandler.get(url + '/projects/fetchAll', {
      params: apiData,
    });
    let projectsData = res.data.data.projectsData;
    let projectsCount = res.data.data.projectsCount;
    // console.log("data res api tokens", res.data.data, isFinished)
    // if ((page.currentValue < page.previousValue) || oldData.length ) {
    //   return;
    // }
    if (projectsData.length < records) {
      setIsFinished(true);
    }

    setCount(projectsCount);
    setLoad(false);
    if (paginate && oldData) {
      let newData = [...oldData, ...projectsData];
      setProjects(newData);
      setLoad(false);
    } else {
      setProjects(projectsData);
      setLoad(false);
    }
    // dispatcher(
    //   showSnackbarAction(res.data.message, "success")
    // );
    // setLoad(false);
    // close();
    // editClose();
  } catch (error: any) {
    // dispatcher(
    //   showSnackbarAction(error.response.data.message, "error")
    // );
    // setLoad(false);
    setLoad(false);
  }
};

export const fetchProjectsFilterValues = async (
  organization_id: string,
  authToken: string,
  dispatcher: any,
) => {
  try {

    let apiData = {
      organization_id
    }
    // console.log("amaklsls", apiData)
    // axios.defaults.headers.common['x-access-token'] = authToken;
    const res = await axiosHandler.get(url + '/projects/filterValues', { params: apiData });
    let data: any = res.data.data[0];
    dispatcher(setFilterObject({ ...data }));
  } catch (error: any) {
    dispatcher(setFilterObject({}))
  }
};

export const deleteProjectMongo = async (
  data: any[],
  dispatcher: any,
  setLoad: (data: boolean) => any,
  authToken: any,
  close: any,
  clearSelectedRowsData: any
) => {
  try {
    let projectIds = [];
    for (let i = 0; i < data.length; i++) {
      projectIds.push(data[i]._id);
    }
    let apiData = {
      projectIds
    }
    const res = await axiosHandler.post(url + '/projects/delete', apiData);
    setLoad(false);
    close();
    dispatcher(
      showSnackbarAction(res.data.message, "success")
    );
    clearSelectedRowsData && clearSelectedRowsData();
    window.location.reload();
  } catch (error: any) {
    dispatcher(
      showSnackbarAction(error.response.data.message, "error")
    );
    setLoad(false);
    // console.log("Upload Error:", error);
  }
};

export const uploadProjectResources = async (
  file: any,
  projectData: any,
  type: string,
  fileName: string,
  dispatcher: any,
) => {
  try {
    if(type === "video"){
      type = "videos";
    }
    if(type === "priceLists"){
      type = "pricelists"
    }
    let file_url = await uploadFileToS3(file, projectData.project_id);
    let fileNameSplit = fileName.split('.');
    let fileType = '';
  
    if (fileNameSplit[fileNameSplit.length - 1] === 'pdf') {
      fileType = 'pdf';
    } else {
      fileType = 'image';
    }
    let attachment = {
      link: file_url,
      name: fileName,
      type: fileType,
    }
    let apiData = {
      attachment,
      resource_type: type,
      project_id: projectData.project_id,
      organization_id: projectData.organization_id,
    }
    const res = await axiosHandler.post(url + '/projectResources/addAttachment', apiData);
    dispatcher(showSnackbarAction(res.data.message, 'success'));
    window.location.reload();
  } catch (error: any) {
    dispatcher(
      showSnackbarAction(error.response.data.message, "error")
    );
  }
};

export const fetchProjectResources = async (
  project_id: string,
  organization_id: string,
  setBrochures: (data: any[]) => void,
  setPriceLists: (data: any[]) => void,
  setLayouts: (data: any[]) => void,
  setForms: (data: any[]) => void,
  setAttachmentsList: (data: any[]) => void,
  setImages: (data: any[]) => void,
  setTemplate: any,
  setMapURL: any,
) => {
  try {
    let res = await axiosHandler.post(url + '/projectResources/getData', {
      organization_id,
      project_id
    })
    let projectResource = res.data.data;
    setTemplate(projectResource.project_description)
    setMapURL(projectResource.project_map_url)
    setBrochures(projectResource.brochures);
    setPriceLists(projectResource.pricelists);
    setAttachmentsList(projectResource.videos);
    setLayouts(projectResource.layouts);
    setForms(projectResource.forms);
    setImages(projectResource.images);
  }
  catch (error) {}
};

export const removeAttachment = async (
  project_id: any,
  organization_id: any,
  attachment: any,
  type: string,
  dispatcher: any,
) => {
  try {
    let apiData = {
      attachment,
      resource_type: type,
      project_id,
      organization_id,
    }
    const res = await axiosHandler.post(url + '/projectResources/removeAttachment', apiData);
    dispatcher(showSnackbarAction(res.data.message, 'success'));
    window.location.reload();
  } catch (error: any) {
    dispatcher(
      showSnackbarAction(error.response.data.message, "error")
    );
  }
};